import { FC, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Popup } from '../../components';
import { CreateScheduleResponseDto } from '../../resources/dtos';
import { UserModel } from '../../resources/models';
import { PhysioConsultation } from './PhysioConsultation';
import { DoctorConsultationCalendly } from './DoctorConsultationCalendly';

export interface ScheduleConsultationPopupProps {
  className?: string;
  user: UserModel;
  onClose(result?: CreateScheduleResponseDto): void;
}

export enum CONSULTATION_TYPE {
  DOCTOR = 'doctor',
  PHYSIO = 'physio',
}

export const ScheduleConsultationPopup: FC<ScheduleConsultationPopupProps> = ({ className, user, onClose }) => {
  const { t } = useTranslation();

  const [consultationType, setConsultationType] = useState<CONSULTATION_TYPE | null>(null);

  return (
    <Popup
      contentClass={classNames('flex flex-col text-typo1', className)}
      width={consultationType === null ? '30rem' : '60rem'}
      height={consultationType === null ? '20rem' : '90vh'}
      disableBackdrop
    >
      <div className="mb-4 flex items-center justify-between gap-4">
        <h1>{t('appointments.schedule.title')}</h1>
        <i className="fa fa-times cursor-pointer text-2xl" onClick={() => onClose()} />
      </div>
      {consultationType === null && (
        <div className="flex h-full flex-col items-center justify-center gap-4">
          <Button
            className="group"
            theme="primary"
            variant="outline"
            fullWidth
            onClick={() => setConsultationType(CONSULTATION_TYPE.DOCTOR)}
          >
            <img
              className="mr-4 h-8 w-auto"
              src="/assets/images/appointments/doctor-consultation.svg"
              alt="doctor consultation"
            />
            {t('appointments.schedule.doctorConsultation')}
          </Button>
          <Button
            className="group"
            theme="primary"
            variant="outline"
            fullWidth
            onClick={() => setConsultationType(CONSULTATION_TYPE.PHYSIO)}
          >
            <img
              className="mr-4 h-8 w-auto"
              src="/assets/images/appointments/physio-consultation.svg"
              alt="physio consultation"
            />
            {t('appointments.schedule.physioConsultation')}
          </Button>
        </div>
      )}
      {consultationType === CONSULTATION_TYPE.DOCTOR && <DoctorConsultationCalendly user={user} onClose={onClose} />}
      {consultationType === CONSULTATION_TYPE.PHYSIO && <PhysioConsultation user={user} onClose={onClose} />}
    </Popup>
  );
};
